import { Maintenance } from '@repo/types';
import dayjs from 'dayjs';

export const isMaintenanceActive = (maintenance?: Maintenance) => {
  if (!maintenance) return false;
  if (
    maintenance?.date_from &&
    maintenance?.date_to &&
    !maintenance?.is_disabled
  ) {
    const now = dayjs();
    const fromDate = dayjs(maintenance.date_from);
    const toDate = dayjs(maintenance.date_to);

    return now.isAfter(fromDate) && now.isBefore(toDate);
  }
  return false;
};
